import { notificationsOrder } from '@/notificationForms'

/**
 * Get the notification to show when the user enter the `setup/notifications` section.
 */
export function useGetFirstActiveNotification() {
  // TODO: retrieve the first active notification
  return notificationsOrder[0]
}
